import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "I learned two things today 29.8.",
  "description": "",
  "published": "2011-08-28T00:00:00.000Z",
  "redirect_from": ["/blog/i-learned-two-things-today-29-8/swizec/2297"],
  "categories": "Learning, Personal",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/08/300px-Lorenz_attractor.svg_.png",
        "alt": "Mathematics",
        "title": "Mathematics"
      }}></img></p>
    <p>{`Today I learned that `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Mathematics",
        "title": "Mathematics"
      }}>{`mathematics`}</a>{` is a very `}<em parentName="p">{`very`}</em>{` dense language. Been studying theoretical basis of computer science for an exam from a `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Textbook",
        "title": "Textbook"
      }}>{`textbook`}</a>{` of some sort. Well actually it's the draft of a textbook that was going to come into existence at some point but hasn't been updated since 2008. There's still references like "I need to put so and so here". It's pretty funny.`}</p>
    <p>{`Funny references aside, it takes a surprisingly long time to read that stuff when you actually read out in your mind what the mathematics is saying instead of just looking at it. I mean it's basically a sentence right, if you want it to stick in your mind at least a little bit you have to read it as a sentence; not just as a random string of characters.`}</p>
    <p>{`Another thing I learned is that you can somewhat almost easily transform a context unaware grammar into such a context unaware grammar as to not contain any needless generations (such that run in loops without ending in a character from the final alphabet) and even such that don't produce any epsilon strings.`}</p>
    <p>{`Apparently this is very useful for minimizing state automata processing such grammars because the language pertaining to that grammar remains the same in all practical aspects.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://worthwhile.typepad.com/worthwhile_canadian_initi/2011/05/bridging-the-mathematics-generation-gap.html"
        }}>{`The mathematics generation gap`}</a>{` (worthwhile.typepad.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://mebassett.blogspot.com/2011/06/you-dont-understand-something-until-you.html"
        }}>{`You don't understand something until you think it's obvious.`}</a>{` (mebassett.blogspot.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://r.zemanta.com/?u=http%3A//www.guardian.co.uk/books/2011/aug/28/genius-basement-alexander-masters-review&a=53261337&rid=4e3b1538-4619-4c97-8258-e9106def5e33&e=883116130eaead154a82a3dffbf7505b"
        }}>{`The Genius in My Basement: the Biography of a Happy Man by Alexander Masters - review`}</a>{` (guardian.co.uk)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://wiki.answers.com/Q/Why_do_textbooks_present_information_as_if_it_were_certain"
        }}>{`Why do textbooks present information as if it were certain`}</a>{` (wiki.answers.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.3quarksdaily.com/3quarksdaily/2011/08/mathematical-learning-and-math-as-a-hobby.html"
        }}>{`Mathematical learning (and math as a hobby)`}</a>{` (3quarksdaily.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://esciencenews.com/articles/2011/08/23/2.year.old.children.understand.complex.grammar"
        }}>{`2-year-old children understand complex grammar`}</a>{` (esciencenews.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=4e3b1538-4619-4c97-8258-e9106def5e33",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      